import { arrayValidation } from './validation';

export const removeSymbolsDuplicates = (arr: Array<any>) => {
  if (!arrayValidation(arr)) return [];
  let symbols: Array<any> = [];
  let instruments: Array<any> = [];
  arr.forEach((instrument) => {
    if (!symbols.includes(instrument.symbol)) {
      symbols = [...symbols, instrument.symbol];
      instruments = [...instruments, instrument];
    }
  });
  return instruments;
};
